import { useTranslation } from 'react-i18next';
import Filter, { FilterDropdownOption } from '../../../../core/components/Filter.tsx';
import * as React from 'react';
import { useQuery } from '@apollo/client';
import { useOverviewContext } from './OverviewContext';
import { GET_DOCUMENT_CLIENT_TYPE_TABLE_FILTER_OPTIONS } from '../../../queries.ts';
import { mapDocumentTypeToGqlDocumentType } from '../../../constants.ts';

const ClientTypeFilter = ({ filters, onFiltersChange }) => {
    const { t } = useTranslation('assistance');

    const [searchValue, setSearchValue] = React.useState('');

    const { documentConfiguration } = useOverviewContext();

    const { data } = useQuery(GET_DOCUMENT_CLIENT_TYPE_TABLE_FILTER_OPTIONS, {
        fetchPolicy: 'cache-and-network',
        variables: {
            documentType: mapDocumentTypeToGqlDocumentType[documentConfiguration.documentType],
            searchTerm: searchValue,
        },
    });

    const filterName = 'client_type';
    const filter = filters.find((f) => f.name === filterName);

    const selected = filter ? (Array.isArray(filter.value) ? filter.value : [filter.value]) : [];

    const options = [
        ...selected.map((value) => ({
            value: value,
            label: value,
        })),
        ...(data?.documentClientTypeTableFilterOptions
            ?.filter((option) => !selected.includes(option.value))
            ?.map((option) => ({
                value: option.value,
                label: option.label,
            })) || []),
    ];

    const handleSelectedChange = (selected: string[]) => {
        const newFilters = filters.filter((f) => f.name !== filterName);
        if (selected.length) {
            newFilters.push({ name: filterName, value: selected, exclude: false, expression: 'eq' });
        }
        onFiltersChange(newFilters);
    };

    return (
        <Filter
            allLabel={t('overview.filters.clientType.all')}
            label={t('overview.filters.clientType.label')}
            options={options}
            selected={selected}
            onSelectedChange={handleSelectedChange}
            multiple
            showSearch
            maxOptions={20}
            searchValue={searchValue}
            onSearchValueChange={setSearchValue}
        />
    );
};

export default ClientTypeFilter;
